import styled from "@emotion/styled";

import { MDSIcon, MDSIconColor, MDSIconKind, MDSText, MDSTextColor, MDSTextVariant } from "@/mds";
import { AgentLinkButton } from "@/pages/agent/components/agent-link-button";
import { decodeAgentDisplayText } from "@/pages/agent/utils/agent-display-text.utils";

export type AgentBreadcrumbItem = {
  label: string;
  onClick?: () => void;
};

export const AgentBreadcrumbs = ({ items }: { items: AgentBreadcrumbItem[] }) => (
  <StyledBreadcrumbs aria-label="Breadcrumb">
    <StyledList>
      {items.map((item, itemIndex) => {
        const isCurrentPage = itemIndex === items.length - 1;
        const label = decodeAgentDisplayText({ value: item.label });

        return (
          <StyledItem key={`${item.label}-${itemIndex}`}>
            {itemIndex > 0 ? (
              <MDSIcon
                aria-hidden="true"
                color={MDSIconColor.Secondary}
                kind={MDSIconKind.AngleRight}
                size={10}
              />
            ) : null}
            {item.onClick && !isCurrentPage ? (
              <StyledLink truncate onClick={item.onClick}>
                {label}
              </StyledLink>
            ) : (
              <StyledCurrent
                aria-current={isCurrentPage ? "page" : undefined}
                color={MDSTextColor.Tertiary}
                variant={MDSTextVariant.TextS}
              >
                {label}
              </StyledCurrent>
            )}
          </StyledItem>
        );
      })}
    </StyledList>
  </StyledBreadcrumbs>
);

const StyledBreadcrumbs = styled.nav`
  min-width: 0;
`;

const StyledList = styled.ol`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[1]};
  list-style: none;
  margin: 0;
  min-width: 0;
  padding: 0;
`;

const StyledItem = styled.li`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
  min-width: 0;
`;

const StyledLink = styled(AgentLinkButton)`
  max-width: 240px;

  && {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextS]};
    text-decoration: none;
  }
`;

const StyledCurrent = styled(MDSText)`
  overflow: hidden;
  max-width: 280px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
